/* eslint-disable no-underscore-dangle */
import { computed } from 'vue';
import { useStore } from 'vuex';

const mapState = () => {
  const store: any = useStore();
  return Object.fromEntries(Object.keys(store.state).map(key => [key, computed(() => store.state[key])]));
};
const mapGetters = () => {
  const store: any = useStore();
  return Object.fromEntries(Object.keys(store.getters).map(getter => [getter, computed(() => store.getters[getter])]));
};
const mapMutations = () => {
  const store: any = useStore();
  return Object.fromEntries(Object.keys(store._mutations).map(mutation => [mutation, (value: any) => store.commit(mutation, value)]));
};
const mapActions = () => {
  const store: any = useStore();
  return Object.fromEntries(Object.keys(store._actions).map(action => [action, (value: any) => store.dispatch(action, value)]));
};
export { mapState, mapGetters, mapMutations, mapActions };
